export const SkipAutoSubmitMagicLinkQueryKey = 'sasml';
